import { useEffect, useState } from "react";

export default function useGithubReadme(owner, repo) {
  const [readme, setReadme] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!owner || !repo) return;

    async function fetchReadme() {
      try {
        setLoading(true);
        setError(null);

        const response = await fetch(
          `https://api.github.com/repos/${owner}/${repo}/readme`,
          {
            headers: {
              Accept: "application/vnd.github+json",
              Authorization: `Bearer ${process.env.REACT_APP_GITHUB_TOKEN}`,
              "X-GitHub-Api-Version": "2022-11-28",
            },
          }
        );

        if (!response.ok) {
          throw new Error("Failed to fetch README");
        }

        const data = await response.json();

        // GitHub returns README content as Base64
        const decoded = atob(data.content);

        setReadme(decoded);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    }

    fetchReadme();
  }, [owner, repo]);

  return {
    readme,
    loading,
    error,
  };
}